const capitalizeFirstLetter= (value) => {
	if (value) return value.charAt(0).toUpperCase() + value.slice(1);
	else return value;
}

export default capitalizeFirstLetter;